var React = require('react');

function FacebookiconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 2V6H15C14.31 6 14 6.81 14 7.5V10H17V14H14V22H10V14H7V10H10V6C10 4.93913 10.4214 3.92172 11.1716 3.17157C11.9217 2.42143 12.9391 2 14 2H17Z","fill":"#767373"}));
}

FacebookiconInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookiconInline;

FacebookiconInline.default = FacebookiconInline;
